import JustValidate from 'just-validate';

const forgottenUserPasswordForm = document.getElementById('forgotten_user_password');
const validator = new JustValidate('#forgotten_user_password');

window.onload = function () {
validator
  .addField('#email', [
    {
      rule: 'required',
      errorMessage: 'E-mail je obavezan',
    },
    {
      rule: 'email',
      errorMessage: 'Email adresa koju ste uneli je nevažeća.',
    },
  ]).onSuccess((() => {
      forgottenUserPasswordForm.submit()
    }))
};